import Helper from '@ember/component/helper';
const passkeyNameToIconName = {
  'Google Password Manager': 'google-password-manager',
  'Chrome on Mac': 'google-chrome',
  'Windows Hello': 'windows-hello',
  'iCloud Keychain (Managed)': 'icloud-keychain',
  Dashlane: 'dashlane',
  '1Password': '1password',
  NordPass: 'nordpass',
  Keeper: 'keeper',
  Sésame: 'sesame',
  Enpass: 'enpass',
  'Chromium Browser': 'google-chrome',
  'Edge on Mac': 'edge',
  IDMelon: 'id-melon',
  Bitwarden: 'bitwarden',
  'iCloud Keychain': 'icloud-keychain',
  'Samsung Pass': 'samsung-pass',
  'Thales Bio iOS SDK': 'thales',
  'Thales Bio Android SDK': 'thales',
  'Thales PIN iOS SDK': 'thales',
  'Thales PIN Android SDK': 'thales',
  'Proton Pass': 'proton-pass',
  KeePassXC: 'kee-pass-xc',
  'ToothPic Passkey Provider': 'toothpic-passkey-provider'
};
const passkeyAaguidToIconName = {
  'ea9b8d66-4d01-1d21-3ce4-b6b48cb575d4': 'google-password-manager',
  'adce0002-35bc-c60a-648b-0b25f1f05503': 'google-chrome',
  '08987058-cadc-4b81-b6e1-30de50dcbe96': 'windows-hello',
  '9ddd1817-af5a-4672-a2b9-3e3dd95000a9': 'windows-hello',
  '6028b017-b1d4-4c02-b4b3-afcdafc96bb2': 'windows-hello',
  'dd4ec289-e01d-41c9-bb89-70fa845d4bf2': 'icloud-keychain',
  '531126d6-e717-415c-9320-3d9aa6981239': 'dashlane',
  'bada5566-a7aa-401f-bd96-45619a55120d': '1password',
  'b84e4048-15dc-4dd0-8640-f4f60813c8af': 'nordpass',
  '0ea242b4-43c4-4a1b-8b17-dd6d0b6baec6': 'keeper',
  '891494da-2c90-4d31-a9cd-4eab0aed1309': 'sesame',
  'f3809540-7f14-49c1-a8b3-8f813b225541': 'enpass',
  'b5397666-4885-aa6b-cebf-e52262a439a2': 'google-chrome',
  '771b48fd-d3d4-4f74-9232-fc157ab0507a': 'edge',
  '39a5647e-1853-446c-a1f6-a79bae9f5bc7': 'id-melon',
  'd548826e-79b4-db40-a3d8-11116f7e8349': 'bitwarden',
  'fbfc3007-154e-4ecc-8c0b-6e020557d7bd': 'icloud-keychain',
  '53414d53-554e-4700-0000-000000000000': 'samsung-pass',
  '66a0ccb3-bd6a-191f-ee06-e375c50b9846': 'thales',
  '8836336a-f590-0921-301d-46427531eee6': 'thales',
  'cd69adb5-3c7a-deb9-3177-6800ea6cb72a': 'thales',
  '17290f1e-c212-34d0-1423-365d729f09d9': 'thales',
  '50726f74-6f6e-5061-7373-50726f746f6e': 'proton-pass',
  'fdb141b2-5d84-443e-8a35-4698c205a502': 'kee-pass-xc',
  'cc45f64e-52a2-451b-831a-4edd8022a202': 'toothpic-passkey-provider'
};
export default class DynamicPasskeySvgIconName extends Helper {
  compute([passkey]) {
    return passkeyAaguidToIconName[passkey.aaguid] ?? passkeyNameToIconName[passkey.name] ?? 'passkey-person-lock';
  }
}